import { ApplicationPreview, Type } from "types";

export type EditCtx = {
  currentUser: any;
  canSubmitApp: boolean;
  canReviewApp: boolean;
  isAgency: boolean;
  isMonitoring: boolean;
  isCgs: boolean;
  assignments: any[];
};

type Rule = {
  when: (tab: Type, app: ApplicationPreview, ctx: EditCtx) => boolean;
  allow: (app: ApplicationPreview, ctx: EditCtx) => boolean;
};

const isRejected = (app: ApplicationPreview) =>
  app?.monitoring_approval_status === "REJECTED";

const isAgencyAssignment = (app: ApplicationPreview, ctx: EditCtx) => {
  const assignmentId = (app.monitoring_assignment as any)?._id ?? app.monitoring_assignment;
  return ctx.assignments.some(
    (a: any) =>
      String(a._id) === String(assignmentId) &&
      a.organization?.org_type === "agency"
  );
};

const isActiveMonitoringAssignment = (app: ApplicationPreview, ctx: EditCtx) => {
  const assignmentId = (app.monitoring_assignment as any)?._id ?? app.monitoring_assignment;
  return (ctx.currentUser?.activeAssignments ?? []).some((a: any) => a._id === assignmentId);
};

export const editRules: Rule[] = [
  {
    when: (tab) => tab === Type.agreement,
    allow: (app, ctx) =>
      !app?.monitoring_approval &&
      !!app?.is_monitorable &&
      (ctx.isAgency || (ctx.isMonitoring && ctx.isCgs)),
  },
  {
    when: (tab, app, ctx) => tab === Type.monitoring && isRejected(app) && ctx.isAgency,
    allow: (app, ctx) => isAgencyAssignment(app, ctx) && (ctx.canSubmitApp || ctx.canReviewApp),
  },
  {
    when: (tab, app, ctx) => tab === Type.monitoring && isRejected(app) && ctx.isMonitoring && ctx.isCgs,
    allow: (app, ctx) => {
      if (ctx.currentUser?._id === app?.assigned_to?._id) return true;
      if (!isActiveMonitoringAssignment(app, ctx)) return false;
      if (ctx.canReviewApp) return true;
      return ctx.isCgs && ctx.currentUser?._id === app?.created_by?._id;
    },
  },
];

export const evaluateEditRules = (tab: Type, app: ApplicationPreview, ctx: EditCtx): boolean =>
  editRules.find((rule) => rule.when(tab, app, ctx))?.allow(app, ctx) ?? false;
